import { render } from "./AddAudios.vue?vue&type=template&id=726251cc"
import script from "./AddAudios.vue?vue&type=script&lang=js"
export * from "./AddAudios.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__